const createCopy = (self: string, carer: string) => ({
    SELF: self,
    CARER: carer,
});

export const AssessmentCopy = {
    SELECT_SUBURB: "Find services near you or someone you care for by selecting a suburb",
    WHO_FOR: "Are you looking for support for yourself or someone else?",
    GENDER_QUESTION: createCopy(
        "How do you describe yourself?",
        "How does the person seeking support describe themself?",
    ),
    AGE_QUESTION: createCopy("How old are you?", "How old are they?"),
    COMMUNITY: createCopy(
        "Do you identify with any of the following? Select all that apply",
        "Does the person seeking support identify with any of the following? Select all that apply",
    ),
    ABOUT: createCopy(
        "A little about you",
        "A little about the person seeking support",
        //Edit answers
    ),
    DISORD_CONCERN: createCopy(
        "Are you looking for support for a specific disorder or concern?",
        "Are you looking for support for a specific disorder or concern?",
        //Edit answers
    ),
    SITUATION: createCopy(
        "Are you looking for support for a challenging situation?",
        "Is the person seeking support for a challenging situation?",
    ),
};
